import { Turbo } from "@hotwired/turbo-rails";
import QRScannerController from "@fire/bridge/qr_scanner_controller";

// walk/WELCOME.md, the scanner. Fire's bridge opens the camera and hands back
// what it read; fire's own next step posts that to a scan list, and here the
// read is only an address. So it goes through the door the paste field uses
// (GET /ballots/scan?code=, or a nota's expenses/new?access_key=) and Turbo takes the page from there.
export default class extends QRScannerController {
  // The query name the read rides on: the urn door's `code`, a nota's `access_key`.
  static values = { ...QRScannerController.values, param: { type: String, default: "code" } };

  handleQrData(value) {
    // The camera keeps reading until somebody closes it: the first read is the visit.
    if (this.visited) return;
    this.visited = true;
    this.send("scanCallback", { result: true });
    // The native camera is continuous: it closes when the page says so.
    this.send("dismiss");
    Turbo.visit(`${this.endpointValue}?${this.paramValue}=${encodeURIComponent(value)}`);
  }
}
